import {Theme, createStyles} from '@material-ui/core';

export const slideStyles = (theme: Theme) =>
	createStyles({
		img: {
			width: '100%',
		},
		slide: {
			maxHeight: theme.typography.pxToRem(410),
			overflow: 'hidden',
			[theme.breakpoints.up(theme.breakpoints.values.lg)]: {
				maxHeight: theme.typography.pxToRem(510),
			},
		},
		slideActive: {
			maxHeight: theme.typography.pxToRem(410),
			overflow: 'hidden',
			transform: 'translateY(0vh) rotateY(20deg) rotateX(8deg)',
			transition: 'transform .3s ease-in-out',
			[theme.breakpoints.up(theme.breakpoints.values.lg)]: {
				maxHeight: theme.typography.pxToRem(510),
			},
		},
		perspective: {
			perspectiveOrigin: 'center center',
		},
	});
